import React from 'react';
import styled, { keyframes } from 'styled-components';
const SpinnerKeyframes = keyframes `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const SpinnerWrapper = styled.div `
  margin: 10px auto;
  width: ${props => `${props.size}px`};
  position: relative;
  transform: translateZ(0);
`;
const SpinnerAnimation = styled.div `
  border-radius: 50%;
  width: ${props => `${props.size}px`};
  height: ${props => `${props.size}px`};
  transform-origin: center;
  animation: ${SpinnerKeyframes} ${props => props.speed || '1s'} infinite linear;
  &:after {
    border-radius: 50%;
    width: ${props => `${props.size}px`};
    height: ${props => `${props.size}px`};
  }
  text-indent: -9999em;
  border-top: ${props => props.size / 10 + 'px'} solid ${props => props.color || props.theme.colors.primary};
  border-right: ${props => props.size / 10 + 'px'} solid ${props => props.color || props.theme.colors.primary};
  border-bottom: ${props => props.size / 10 + 'px'} solid ${props => props.color || props.theme.colors.primary};
  border-left: ${props => props.size / 10 + 'px'} solid #ffffff;
`;
export const Spinner = ({ size = 25, speed = '0.6s', color }) => {
    return React.createElement(SpinnerWrapper, { className: "spinner", size: size, speed: speed, color: color },
        React.createElement(SpinnerAnimation, { size: size, speed: speed, color: color }));
};
